export default "__VITE_ASSET__ux1LxUwM__"